import gql from 'graphql-tag';

import { sectionERFragment } from './section-er';
import { applicationSectionFragment } from './application';

/**
 * Contains the entirety of an EV application. Only use this if you need all EV application data.
 */
export const applicationERFragment = gql`
  fragment applicationERFragment on ApplicationER {
    details {
      ...applicationSectionFragment
      ...sectionERFragment
    }
  }
  ${applicationSectionFragment}
  ${sectionERFragment}
`;
